<template>
  <b-container fluid class="attivazione">
    <h3 class="mt-2">Benvenuto su GiustUp!</h3>

    <div>
      <p class="mt-2">Associa un account di un social network per accedere a GiustUp:</p>

      <b-button class="google" @click="login('Google')">
        <font-awesome-icon :icon="['fab', 'google']" />&nbsp;&nbsp;&nbsp;&nbsp;
        Google
      </b-button>
      <!--
      <b-button class="facebook" @click="login('Facebook')">
        <font-awesome-icon :icon="['fab', 'facebook']" />&nbsp;&nbsp;&nbsp;&nbsp;
        Facebook
      </b-button>
      -->
    </div>
  </b-container>
</template>

<script>
import oauth from '../services/oauth.js'
import api from '../services/service.js'

export default {
  name: 'attivazione',
  data () {
    return {
    }
  },
  methods: {
    async login(provider) {
      let prov = oauth.get(provider);

      //salva token di attivazione nella richiesta
      prov.options.query.state.provider = provider;
      prov.options.query.state.attivazioneToken = this.$route.query.token;
      prov.options.query.state = JSON.stringify(prov.options.query.state);
      let uri = prov.code.getUri();

      location.assign(uri);
    }
  },
  async created() {
    let parameters = this.$route.query;
    if (parameters.token === undefined) {
      // location.href = "https://landing.giustup.it/";
      this.$router.push({name: "Home"});
    }
    else {
      let body = {'token': parameters.token};
      let error = true;
      try {
        let data = await api.execute('post', 'utente/verificaAttivazione', body, true);
        if(data.status === 200) // ok token valido
        {
          error = false;
        }
      }
      catch (e) {
      }
      if(error) { // token non valido
        // location.href = "https://landing.giustup.it/";
        this.$router.push({name: "Home"});
      }
      else { // ok token valido
        this.$parent._data.loaded = true;
      }
    }
  }
}
</script>

<style>
.facebook {
  min-width: 140px;
  background-color: #4C69BA !important;
  border: none;
}
.google {
  min-width: 140px;
  background-color: #DD4B39 !important;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Attivazione.vue